import script from "./EmergencyPatientList.vue?vue&type=script&setup=true&lang=js"
export * from "./EmergencyPatientList.vue?vue&type=script&setup=true&lang=js"

import "./EmergencyPatientList.vue?vue&type=style&index=0&id=58e9a46d&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e9a46d"]])

export default __exports__